import PropTypes from 'prop-types';

export default PropTypes.shape({
  code: PropTypes.string,
  name: PropTypes.string,
  seatMapName: PropTypes.string
});
